<template>
    <transition name="fade">
        <div class="to-top-btn" @click="to_top" v-show="btn_status">
            <div class="arrow">
                <div class="line line1"></div>
                <div class="line line2"></div>
            </div>
            <div class="text">TOP</div>
        </div>
    </transition>
</template>
<script>
export default {
    data(){
        return {
            btn_status: false,
            window_top: 0,
            window_h: 0
        }
    },
    methods: {
        to_top(){
            $("HTML, BODY").animate({ scrollTop: 0 }, 500);
        }
    },
    mounted(){
        $(window).scroll(()=>{
            this.window_top = $(window).scrollTop();
            this.window_h = $(window).height();
            this.btn_status = (this.window_top>this.window_h)?true:false;
        });
    }
}
</script>
<style lang="sass">
.to-top-btn
    width: 60px
    height: 60px
    position: fixed
    right: 0
    z-index: 100
    top: 80%
    background: black
    right: 10px
    border-radius: 50%
    opacity: 0.6
    cursor: pointer
    display: none
    @media (max-width: 768px)
        display: block
    .text
        color: white
        text-align: center
        position: absolute
        position: absolute
        top: 50%
        left: 50%
        -webkit-transform: translate(-50%, -50%)
        -ms-transform: translate(-50%, -50%)
        transform: translate(-50%, -50%)
        top: 65%
        font-weight: 100
        font-size: 14px
    .arrow
        width: 45%
        height: 45%
        position: absolute
        left: 50%
        top: 55%
        -webkit-transform: rotate(45deg) translate(-50%, -50%)
        -ms-transform: rotate(45deg) translate(-50%, -50%)
        transform: rotate(45deg) translate(-50%, -50%)
        -webkit-transform-origin: 0 0
        -ms-transform-origin: 0 0
        transform-origin: 0 0
        .line
            background: white
            position: absolute
        .line1
            width: 100%
            height: 2px
        .line2
            height: 100%
            width: 2px



.fade-enter-active, .fade-leave-active
    transition: opacity .5s;

.fade-enter, .fade-leave-to
    opacity: 0;


</style>



// WEBPACK FOOTER //
// src/ToTopBtn.vue